
      if (typeof __webpack_require__ !== "undefined") {
        var originalGet = __webpack_require__.u;
        var originalEnsure = __webpack_require__.e;
        var queryMap = {};
        var countMap = {};

        var withRetryQuery = function(chunkId, result) {
          return result + (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '');
        };

        __webpack_require__.u = function(chunkId) {
          return withRetryQuery(chunkId, originalGet(chunkId));
        };

        // Cache-bust должен попадать и на CSS-чанки, иначе повтор уходит по тому же
        // адресу и получает тот же отрицательный кэш, что и первая попытка.
        // Оборачиваем лениво: mini-css-extract ставит miniCssF своим runtime-модулем,
        // и на момент STAGE_ATTACH его может ещё не быть.
        var miniCssWrapped = false;
        var wrapMiniCssF = function() {
          if (miniCssWrapped) return;
          var originalMiniCssF = __webpack_require__.miniCssF;
          if (typeof originalMiniCssF !== "function") return;
          miniCssWrapped = true;
          __webpack_require__.miniCssF = function(chunkId) {
            return withRetryQuery(chunkId, originalMiniCssF(chunkId));
          };
        };

        __webpack_require__.e = function(chunkId) {
          wrapMiniCssF();
          var result = originalEnsure(chunkId);
          return result.catch(function(error) {
            var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 4;
            if (retries < 1) {
              // Имя файла в сообщении — единственный способ понять по логам, какой
              // именно чанк не доехал, поэтому формат совпадает с прежним плагином.
              var realSrc = originalGet(chunkId);
              error.message = 'Loading chunk ' + chunkId + ' failed after 4 retries.\n(' + realSrc + ')';
              error.request = realSrc;
              
    try {
      var reloadKey = '__eatsChunkReloadAt__';
      var lastReloadAt = Number(window.sessionStorage.getItem(reloadKey)) || 0;
      var now = Date.now();
      if (now - lastReloadAt > 60000) {
        window.sessionStorage.setItem(reloadKey, String(now));
        window.location.reload();
      }
    } catch (e) {}

              throw error;
            }
            return new Promise(function(resolve) {
              var retryAttempt = 4 - retries + 1;
              var baseDelay = true ? 250 * retryAttempt : 250;
              // Разброс разводит повторы разных чанков одной страницы во времени:
              // без него все 4 попытки укладываются в ~2.5 с и выгорают на одном
              // и том же сетевом блипе.
              var delay = baseDelay + Math.round(Math.random() * 250);
              setTimeout(function() {
                var retryAttemptString = '&r=' + retryAttempt;
                var cacheBust = Date.now();
                var query = cacheBust + retryAttemptString;
                queryMap[chunkId] = query;
                countMap[chunkId] = retries - 1;
                resolve(__webpack_require__.e(chunkId));
              }, delay);
            });
          });
        };
      }
        